import type { parseQuery, RouteLocationNormalized, stringifyQuery } from 'vue-router';
import { createRouter as createVueRouter, createWebHistory } from 'vue-router';

import qs from 'qs';

import getRoutes from './getRoutes';

const getRouteTitle = (route: RouteLocationNormalized): string => {
  if (typeof route.meta.title === 'string' && route.meta.title.trim() !== '') {
    return route.meta.title.trim();
  }
  return 'Binom';
};

export function createRouter(routerPrefix: string) {
  const router = createVueRouter({
    history: createWebHistory(`/${routerPrefix}/`),
    parseQuery: qs.parse as typeof parseQuery,
    routes: getRoutes(),
    stringifyQuery: qs.stringify as typeof stringifyQuery,
  });

  router.beforeEach((to, from, next) => {
    document.title = getRouteTitle(to);
    next();
  });

  return router;
}
